import { render } from "./BoxIcon.vue?vue&type=template&id=afcbe95e"
import script from "./BoxIcon.vue?vue&type=script&lang=js"
export * from "./BoxIcon.vue?vue&type=script&lang=js"

import "./BoxIcon.vue?vue&type=style&index=0&id=afcbe95e&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__